import {Checkbox, Flex, Select, Tooltip, Typography} from "antd";
import {ReportsFilter, UserValue} from "./index";
import {debounce} from "lodash";
import IconArrowDownSmall from "../../components/ui/icons/IconArrowDownSmall";
import React from "react";
import type {DefaultOptionType} from "antd/es/select";

const {Text} = Typography;

interface FilterSelectProps {
  name: 'pools' | 'companies' | 'products' | 'kpis',
  options: DefaultOptionType[],
  setSearch: Function,
  setFilter: Function,
  filter: ReportsFilter,
  placeholder: string,
  onValueChange: Function,
  disabled: boolean,
  showSearch?: boolean,
  status?: "" | "warning" | "error" | undefined
}

export default function FilterSelect({
                                       name,
                                       options,
                                       setSearch,
                                       setFilter,
                                       filter,
                                       placeholder,
                                       onValueChange,
                                       disabled,
                                       showSearch = false,
                                       status,
                                     }: FilterSelectProps) {
  return (
    <Select
      style={{width: 200}}
      showSearch={showSearch}
      allowClear
      labelInValue
      placeholder={placeholder}
      optionFilterProp="children"
      mode="multiple"
      maxTagCount={'responsive'}
      maxTagTextLength={10}
      maxTagPlaceholder={(omittedValues) => (
        <Tooltip
          title={omittedValues.map(({label}) => label).join(', ')}
        >
          <span>+{omittedValues.length}</span>
        </Tooltip>
      )}
      onChange={(data: UserValue[]) => {
        onValueChange();
        setFilter({
          ...filter,
          [name]: data,
        })
      }}
      optionRender={(option) => (
        <Flex align={'center'} gap={8}>
          <Checkbox
            checked={
              filter[name]?.some((item: UserValue) => item.value === option.data.value)
            }
          />
          <Text ellipsis style={{fontSize: 12}}>{option.label}</Text>
        </Flex>
      )}
      onSearch={showSearch ? debounce((value: string) => {
        setSearch(value)
      }, 600) : () => {}}
      filterOption={false}
      options={options}
      value={filter[name]}
      size={'large'}
      suffixIcon={<IconArrowDownSmall/>}
      disabled={disabled}
      autoClearSearchValue={false}
      onDropdownVisibleChange={(open: boolean) => {
        if (!open) {
          setSearch('')
        }
      }}
      status={status}
    />
  )
}
